import { useTheme } from '@mui/material';
import { IconChartPie } from '@tabler/icons-react';

import { Button, Tooltip } from '@zendesk/forethought-elements';
import { useGetFeatureFlagsQuery } from 'src/services/dashboard-api';
import { setGlobalWorkflowBuilderOptions } from 'src/slices/ui/uiSlice';
import { useAppDispatch } from 'src/store/hooks';

export default function CustomEventsButton({
  isDarkMode,
}: {
  isDarkMode: boolean;
}) {
  const dispatch = useAppDispatch();
  const { palette } = useTheme();
  const { data: featureFlagsData } = useGetFeatureFlagsQuery();
  const { feature_flags: featureFlags = [] } = featureFlagsData ?? {};
  const isCustomMetricsEnabled = featureFlags.includes('custom_metrics');

  return (
    isCustomMetricsEnabled && (
      <Tooltip tooltipContent='Custom events'>
        <Button
          onClick={() =>
            dispatch(
              setGlobalWorkflowBuilderOptions({
                isCustomEventsDrawerOpen: true,
              }),
            )
          }
          startIcon={
            <IconChartPie
              color={
                isDarkMode ? palette.colors.white : palette.colors.grey[700]
              }
              size={20}
            />
          }
          variant='ghost'
        />
      </Tooltip>
    )
  );
}
